import React from 'react'
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import webLogin from '../../types/webLogin';

function UserMenuComponent(props: any) {
    if ( props.loginContext.administrator !== "1" && props.loginContext.administrator !== "2" ) {
        return (
        <div className='items-center'>
            <i className="pi pi-spin pi-spinner"></i> Cargando...
        </div>
        )
    } else 
    return (
        <>
            {
            props.loginContext.administrator === "0" &&
            <div>
                {/* grupo */}
                <div className='font-bold mb-2 mt-2 flex items-center text-sm 2xl:text-base'>
                    Comprobantes
                </div>
                <div>
                    <ul className='mt-0 pl-0 space-y-3' style={{textDecoration: 'none', listStyle: 'none'}}>
                        <li>
                            <Link to={'/resumen'} className='text-white flex items-center text-sm 2xl:text-base ds-link-default ds-link-fit-content' ><i className="material-icons-outlined md-18 ">dashboard</i>&nbsp; Resumen</Link>
                        </li>
                        <li>
                            <Link to={'/emitidos'} className='text-white flex items-center text-sm 2xl:text-base ds-link-default ds-link-fit-content' ><i className="material-icons-outlined md-18 ">call_made</i>&nbsp; Emitidos</Link>
                        </li>
                        <li>
                            <Link to={'/recibidos'} className='text-white flex items-center text-sm 2xl:text-base ds-link-default ds-link-fit-content' ><i className="material-icons-outlined md-18 ">call_received</i>&nbsp; Recibidos</Link>
                        </li>
                        <li>
                            <Link to={'/aprobacion'} className='text-white flex items-center text-sm 2xl:text-base ds-link-default ds-link-fit-content' ><i className="material-icons-outlined md-18 ">check</i>&nbsp; Aprobaci&oacute;n</Link>
                        </li>
                    </ul>
                </div>
            </div>
            }
            {
            props.loginContext.administrator === "1" &&
            <div>
                {/* grupo */}
                <div className='font-bold mb-2 flex items-center text-sm 2xl:text-base mt-12'>
                    Soporte
                </div>
                <div>
                    <ul className='mt-0 pl-0 space-y-2' style={{textDecoration: 'none', listStyle: 'none'}}>
                        <li>
                            <Link to={'/clientes'} className='text-white flex items-center text-sm 2xl:text-base ds-link-default ds-link-fit-content'><i className="material-icons-outlined md-18 ">list</i>&nbsp; Clientes</Link>
                        </li>
                        <li>
                            <Link to={'/certificates'} className='text-white flex items-center text-sm 2xl:text-base' style={{ textDecoration: 'none' }}><i className="material-icons-outlined md-18 ">admin_panel_settings</i>&nbsp; Certificados</Link>
                        </li>
                        {/* <li>
                            <Link to={'/autorizacion'} className='text-white flex items-center text-sm 2xl:text-base ds-link-default ds-link-fit-content'><i className="material-icons-outlined md-18 ">verified_user</i>&nbsp; Authorizar Rutas</Link>
                        </li>
                        <li>
                            <Link to={'/enviardata'} className='text-white flex items-center text-sm 2xl:text-base ds-link-default ds-link-fit-content'><i className="material-icons-outlined md-18 ">forward_to_inbox</i>&nbsp; Enviar Uso</Link>
                        </li> */}
                    </ul>
                </div>
            </div>
            }
            {
            props.loginContext.administrator === "0" &&
            <div>
                {/* grupo */}
                <div className='font-bold mb-2 flex items-center text-sm 2xl:text-base mt-12'>
                    Usuario
                </div>
                <div>
                    <ul className='mt-0 pl-0 space-y-2' style={{textDecoration: 'none', listStyle: 'none'}}>
                        {/* <li>
                            <Link to={'/perfil'} className='text-white flex items-center text-sm 2xl:text-base  ds-link-default ds-link-fit-content'><i className="material-icons-outlined md-18 ">person</i>&nbsp; Perfil</Link>
                        </li> */}
                        <li>
                            <Link to={'/configuracion'} className='text-white flex items-center text-sm 2xl:text-base  ds-link-default ds-link-fit-content'><i className="material-icons-outlined md-18 ">manage_accounts</i>&nbsp; Configuraci&oacute;n</Link>
                        </li>
                    </ul>
                </div>
            </div>
            }
        </>
    )
}

UserMenuComponent.propTypes = {
  loginContext: PropTypes.any.isRequired
};


export default UserMenuComponent;